/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreateCouponRequestViewModel } from "../types/CreateCouponRequestViewModel.ts";

export const createCouponRequestViewModelSchema = z.object({
  description: z.string().describe("Descrição do cupom.").nullish(),
  dateStart: z.optional(
    z.string().datetime().describe("Data de início da validade do cupom."),
  ),
  dateEnd: z.optional(
    z
      .string()
      .datetime()
      .describe(
        "Data final da validade do cupom. Deve ser maior ou igual à data de início.",
      ),
  ),
  quantity: z
    .number()
    .int()
    .describe(
      "Quantidade de utilizações permitidas. No cupom automático, define quantos códigos serão gerados. Opcional.",
    )
    .nullish(),
  automatic: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o cupom é automático (gera vários códigos únicos) ou manual (um único código informado em Hash).",
      ),
  ),
  hash: z
    .string()
    .describe(
      "Código do cupom manual. Obrigatório quando o cupom não é automático. Opcional.",
    )
    .nullish(),
  discountPercentage: z
    .number()
    .describe("Percentual de desconto aplicado. Valor entre 0 e 100. Opcional.")
    .nullish(),
  discountValue: z
    .number()
    .describe("Valor fixo de desconto aplicado. Opcional.")
    .nullish(),
  companyId: z
    .number()
    .int()
    .describe("ID da empresa associada ao cupom. Opcional.")
    .nullish(),
  cumulative: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o desconto do cupom pode ser acumulado com outros descontos.",
      ),
  ),
  gift: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o cupom é uma cortesia (zera o valor da matrícula).",
      ),
  ),
  active: z.optional(
    z.boolean().describe("Indica se o cupom deve ser criado ativo."),
  ),
  classStudentIds: z
    .array(z.number().int())
    .describe("IDs das turmas a vincular ao cupom.")
    .nullish(),
}) as unknown as ToZod<CreateCouponRequestViewModel>;
